import { render, staticRenderFns } from "./FapiaoApplicationInfo.vue?vue&type=template&id=3bb00552&scoped=true"
import script from "./FapiaoApplicationInfo.vue?vue&type=script&lang=js"
export * from "./FapiaoApplicationInfo.vue?vue&type=script&lang=js"
import style0 from "./FapiaoApplicationInfo.vue?vue&type=style&index=0&id=3bb00552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb00552",
  null
  
)

export default component.exports